import * as dialog from '../components/dialog';
import {subscribe} from '../helpers/pubSub';

//Runs after modal instance is rendered.
function _modalCreatedCallback() {
    var selRefills = [],
        refillSels = document.querySelectorAll('[data-sel-refillid]'),
        refillOpts = document.querySelectorAll('[data-opts-refillid]');

    if (refillSels.length > 0 && refillOpts.length > 0) {
        [].forEach.call(refillSels, refill => selRefills.push(refill.dataset.selRefillid));

        [].forEach.call(refillOpts, refillOpt => selRefills.indexOf(refillOpt.value) > -1 ? refillOpt.checked = true : refillOpt.checked = false);
    }
}

function _addRefillElementBlock(data) {
    let container = document.querySelector('[data-product-component="selected-refills"]'),
        refillTemplate = document.querySelector('[data-refill-template]').firstElementChild.cloneNode(true);

    refillTemplate.dataset.selRefillid = refillTemplate.dataset.pid = data.id;
    refillTemplate.dataset.productContainer = 'set-item';
    refillTemplate.querySelector('img').src = data.productThumbnail && data.productThumbnail.url ? data.productThumbnail.url : '';
    refillTemplate.querySelector('[data-refill-name]').textContent = data.productName ? data.productName : '';
    refillTemplate.querySelector('[data-refill-ref]').textContent = data.reference ? data.reference : '';
    //refillTemplate.querySelector('[data-refill-price]').textContent = data.formattedSalesPrice ? data.formattedSalesPrice : '';

    container.appendChild(refillTemplate);

    [].forEach.call(document.querySelectorAll('[data-refill-remove]'), currentItem => currentItem.addEventListener('click', function() {
        this.parentNode.remove();
        _handleAddToCartButtonStatus();
        _recalculateBundlePrice();
    }));
}

export function _handleAddToCartButtonStatus() {
    var addToCartBtn = document.querySelector('.case-refill-req'),
        container = document.querySelector('[data-product-component="selected-refills"]'),
        refillSels = '';
    if (container) {
        refillSels = container.querySelectorAll('[data-sel-refillid]');
    }

    if (addToCartBtn && !addToCartBtn.hidden && refillSels && refillSels.length > 0) {
        addToCartBtn.disabled = false;
        if (addToCartBtn.classList.contains('hide-select-size')) {
            addToCartBtn.classList.remove('hide-select-size');
        } else {
            addToCartBtn.classList.add('hide-select-size');
        }
    } else {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('hide-select-size');
    }
}

function _recalculateBundlePrice() {
    var container = document.querySelector('[data-product-component="selected-refills"]'),
        refillSels = container.querySelectorAll('[data-sel-refillid]'),
        productData = [],
        formData = {};

    [].forEach.call(refillSels, function(currentItem) {
        let pid = currentItem.getAttribute('data-pid');
        productData.push(pid);
    });

    formData.pidsArr = JSON.stringify(productData);

    $.ajax({
        url: container.dataset.url || '',
        method: 'POST',
        data: formData,
        success: function(data) {
            _updatePrice(data.bundlePrice);
        }
    });
}

function _updatePrice(priceObj) {
    var priceContainer = document.querySelector('[data-product-component="price"]');

    if (priceContainer) {
        let titleSpan = priceContainer.querySelector('span.tile-label'),
            priceOriginalSpan = priceContainer.querySelector('span.price__original'),
            priceSalesSpan = priceContainer.querySelector('span.price__sales > span.value'),
            priceSalesSpanContent = priceSalesSpan.getAttribute('content');
        if (titleSpan) {
            if ('showStartingFrom' in priceObj && priceObj.showStartingFrom && titleSpan.classList.contains('hidden')) {
                titleSpan.classList.remove('hidden');
            } else {
                titleSpan.classList.add('hidden');
            }
        }

        if (priceOriginalSpan != null) {
            priceOriginalSpan.classList.add('hidden');
        }

        if (priceSalesSpan && 'sales' in priceObj && priceObj.sales) {
            if (priceSalesSpanContent) {
                priceSalesSpan.setAttribute('content', priceObj.sales.decimalPrice);
            }

            priceSalesSpan.innerHTML = priceObj.sales.formatted;
        }
    }
}

function _showSelectedRefills(data) {
    var container = document.querySelector('[data-product-component="selected-refills"]');

    if (data.response && data.response.selectedRefills) {
        container.innerHTML = '';

        let selRefills = JSON.parse(data.response.selectedRefills);

        [].forEach.call(selRefills, selRefill => _addRefillElementBlock(selRefill));

        _handleAddToCartButtonStatus();
        _updatePrice(data.response.bundlePrice);
    }
}

export function refillsSetup() {
    let addRefillBtn = document.querySelector('.product-addrefill__button');

    subscribe('validateRefills:success', data => _showSelectedRefills(data));

    subscribe('validateRefills:error', () => {
        let refillOpts = document.querySelectorAll('[data-opts-refillid]');

        [].forEach.call(refillOpts, currentItem => currentItem.addEventListener('change', function() {
            document.querySelector('[data-refill-error]').classList.remove('set--visible');
        }));
    });

    if (addRefillBtn) {
        addRefillBtn.addEventListener('click', function() {
            dialog.open({
                url: this.dataset.url || '',
                type: 'html',
                callback: _modalCreatedCallback,
                options: {
                    modalID: 'fragrances-' + this.dataset.pid,
                    modalClass: 'modal--refill',
                    keepAlive: false
                }
            });
        });
    }
}

